import React from "react"
import { DeleteWithConfirmButton, useRecordContext, useTranslate } from "react-admin"

interface props {
    field: string
    title: string
}

export default function DeleteWithConfirmButtonX(props: props): JSX.Element {
    const { field, title } = props
    const record = useRecordContext()
    const translate = useTranslate()

    if (!record) return <></>

    return (
        <DeleteWithConfirmButton
            label=""
            title={title}
            confirmTitle={`${translate("ra.action.delete")} "${record[field]}"`}
            confirmContent={`${translate("ra.message.delete_content")}?`}
        />
    )
}

